import { cn } from "@/packages/utils";

interface BrandIconProps {
  /** Background color for the circle (e.g. workspace accent color) */
  color?: string;
  className?: string;
}

/**
 * Inline SVG brand icon — four shapes on a colored circle.
 * The circle color adapts to the workspace accent color.
 */
export function BrandIcon({
  color = "var(--color-accent)",
  className,
}: BrandIconProps) {
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full",
        className,
      )}
      style={{ backgroundColor: color }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="200 200 754 754"
        className="h-[62%] w-[62%]"
        role="img"
        aria-label="Audinero"
      >
        {/* Top-left rounded square */}
        <path
          fill="currentColor"
          d="M408.555 576.258H241.488V409.191c0-92.617 75.086-167.703 167.703-167.703h167.067v167.062c0 92.621-75.086 167.708-167.703 167.708z"
        />
        {/* Bottom-right rounded square */}
        <path
          fill="currentColor"
          d="M755.262 923.234H588.195V756.172c0-92.617 75.09-167.703 167.707-167.703h167.063v167.062c0 92.617-75.086 167.703-167.703 167.703z"
        />
        {/* Top-right rounded shape */}
        <path
          fill="currentColor"
          d="M756.223 582.387h4.914c92.742 0 167.957-75.219 167.957-168.027v-4.914c0-92.742-75.215-167.957-168.023-167.957H588.027c-.484 0-.832.414-.832.832v172.04c0 92.808 75.219 168.026 168.028 168.026z"
        />
        {/* Bottom-left rounded shape */}
        <path
          fill="currentColor"
          d="M404.078 929.363h4.918c92.738 0 167.953-75.215 167.953-168.023v-4.918c0-92.738-75.215-167.953-168.024-167.953H236.883c-.484 0-.828.414-.828.828v172.043c0 92.808 75.215 168.023 168.023 168.023z"
        />
      </svg>
    </div>
  );
}
